
import {
  defineComponent,
  reactive,
  toRefs,
  nextTick,
  ref,
  onMounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import Todiskilltime from "@/components/todiskilltime/index.vue";
import { ElMessage } from 'element-plus'
import { typeLists, addTypes, deleteTypes, updateTypes } from "@/apis/group";
export default defineComponent({
  components: {
    Todiskilltime,
  },
  setup() {
    let todiskilltime = ref();
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      tableDatatiming: [],
      todisbinfalge: false,
      inputchanshang: "",
      inputdizhi: "",
      inputbeizhu: "",
      pleaase1: "",
      pleases3: "",
      setconfim: "",
      inputkilltrue: "1min",
      inputkillnumber: 60,
      inputsbmc: "",
      deletecompanyfalge: false,
      deletedetail: null,
      typeid:null,
      pleases2:''
    });
    const method = reactive({
      killtrue(): void {
        if (state.setconfim === "set") {
          method.setkillsj(state.inputkillnumber);
        }
        todiskilltime.value.timeflage = true;
      },
      setkillsj(numberss: any): void {
        todiskilltime.value.overindex = Math.floor(numberss / 60);
        todiskilltime.value.overmiaoindex = numberss % 60;
        todiskilltime.value.defaultValuefen = Math.floor(numberss / 60);
        todiskilltime.value.defaultValuemiao = numberss % 60;
      },
      timesvaluedurion(value1: any, value2: any) {
        state.inputkilltrue =
          value1 + "min" + (value2 === 0 ? "" : value2 + "s");
        state.inputkillnumber = value1 * 60 + value2;
      },
      setdisbin(index: number, rows: any) {
        state.setconfim = "set";
        console.log(index, rows);
        state.inputsbmc = rows.deviceName;
        state.inputdizhi = rows.deviceModel;
        state.inputbeizhu = rows.uvTime;
        state.inputkilltrue =
          Math.floor(rows.uvTime / 60) +
          "min" +
          (rows.uvTime % 60 === 0 ? "" : (rows.uvTime % 60) + "s");
        state.inputkillnumber = rows.uvTime;
        state.typeid = rows.deviceId
        state.todisbinfalge = true;
      },
      removebin(index: number, rows: any) {
        console.log(index, rows);
        state.deletedetail = rows;
        //   state.timingtaskdetail = rows;
        //   state.timingindex = index;
        state.deletecompanyfalge = true;
      },
      detelechangshang(elsa: any) {
        deleteTypes({
          id: elsa.deviceId,
        }).then((resdea: any) => {
          console.log(resdea);
          if (resdea.code === 200) {
            method.gettyplistss();
            state.deletecompanyfalge = false;
          }
        });
      },
      newtodisbin() {
        state.setconfim = "add";
        state.todisbinfalge = true;
        state.inputkillnumber = 60;
      },
      canceltodis() {
        state.todisbinfalge = false;
        nextTick(() => {
          state.pleaase1 = "";
          state.pleases3 = "";
          state.inputdizhi = "";
          state.inputbeizhu = "";
          if (state.setconfim === "add") {
            state.inputkilltrue = '1min';
            state.inputkillnumber = 60
          }
          state.inputsbmc = "";
        });
      },
      canceltingflage() {
        state.deletecompanyfalge = false
      },
      gettyplistss() {
        typeLists({
          ids: route.params.ids,
        }).then((ssres: any) => {
          console.log(ssres);
          state.tableDatatiming = ssres.data.typeList;
          state.inputchanshang = ssres.data.vendorName
        });
      },
      Shutdowntodis() {
        if (state.inputsbmc === "") {
          state.pleaase1 = "请输入设备名称";
          state.pleases3 = "";
           state.pleases2 = ''
        } else if (state.inputdizhi === '') {
          state.pleases2 = '请输入设备型号'
          state.pleaase1 = "";
          state.pleases3 = '';
        } else if (state.inputkillnumber === null) {
          state.pleases3 = "请选择消毒时间";
          state.pleaase1 = "";
          state.pleases2 = "";
        } else {
          if (state.setconfim === "set") {
            console.log("我是设置");
            updateTypes({
              deviceModel: state.inputdizhi,
              deviceName: state.inputsbmc,
              deviceid: state.typeid,
              uvTime: state.inputkillnumber
            }).then((updatyperes:any)=>{
              console.log(updatyperes)
              if (updatyperes.code === 200) {
                ElMessage({
                  message:'编辑设备型号成功',
                  type:'success'
                })
                method.gettyplistss();
                state.todisbinfalge = false;
                nextTick(() => {
                  state.pleaase1 = "";
                  state.pleases3 = "";
                  state.inputdizhi = "";
                  state.inputbeizhu = "";
                  state.inputkilltrue = "";
                  state.inputsbmc = "";
                  state.typeid = null
                  state.pleases2 = ''
                });
              } else {
                 ElMessage({
                  message:updatyperes.msg
                })
              }
            })
          } else {
            console.log("我是新增");
            addTypes({
              companyid: route.params.ids,
              deviceModel: state.inputdizhi,
              deviceName: state.inputsbmc,
              uvTime: state.inputkillnumber,
            }).then((addres: any) => {
              console.log(addres);
              if (addres.code === 200) {
                ElMessage({
                  message:'添加设备型号成功',
                  type:'success'
                })
                method.gettyplistss();
                state.todisbinfalge = false;
                nextTick(() => {
                  state.pleaase1 = "";
                  state.pleases3 = "";
                  state.inputdizhi = "";
                  state.inputbeizhu = "";
                  state.inputkilltrue = "1min";
                  state.inputkillnumber = 60
                  state.inputsbmc = "";
                  state.pleases2 = ''
                });
              } else {
                 ElMessage({
                  message:addres.msg
                })
              }
            });
          }
        }
      },
    });
    onMounted(() => {
      method.gettyplistss();
    });
    return {
      ...toRefs(state),
      ...toRefs(method),
      todiskilltime,
    };
  },
});
